import moment from "moment";
import momentTz from "moment-timezone";

import cardValidator from "card-validator";
import {CONSTANTS} from "./constants";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const getBaseUrl = () => {
  let _location = window.location.href;
  if (_location.indexOf('#') > -1) {
    return _location.split('#')[0];
  }
  return _location;
}

export const getPreferenceValue = (preferences, key, defaultValue) => {
    let pref = preferences[key] || defaultValue;
    return pref;
}

export const exportIcalendar = (events, calendarName) => {
  let icsContent = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "CALSCALE:GREGORIAN",
    `X-WR-CALNAME:${calendarName}`
  ];
  events.forEach((event, index) => {
    icsContent.push(
      "BEGIN:VEVENT",
      `UID:${Date.now()}-${index}@mycalendar.com`,
      `DTSTAMP:${formatIsoDate(new Date().toISOString())}`,
      `DTSTART:${formatIsoDate(event.start)}`,
      `DTEND:${formatIsoDate(event.end)}`,
      `SUMMARY:${event.title}`,
      `DESCRIPTION:${event.description || ''}`,
      `LOCATION:${event.location || ''}`,
      "END:VEVENT"
    );
  });

  icsContent.push("END:VCALENDAR");

  const blob = new Blob([icsContent.join("\r\n")], {type: "text/calendar"});
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = "calendar.ics";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);

}

export const checkFormValidity = (event) => {
  let elements = event.target.form.elements;
  let valid = true;
  for (let el in elements) {
    if (elements[el].checkValidity) {
      valid = valid && elements[el].checkValidity();
    }
  }
  return valid;
}

export const isGuid = (str) => {
  const uuidV4Regex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidV4Regex.test(str);
}

export const sortAttendeesFunction = (a, b) => {
  const getRank = (person) => {
    if (person.primary) return 1;
    if (person.adult && !person.dob) return 2;
    if (person.adult) return 3;
    return 4;
  };

  const rankDiff = getRank(a) - getRank(b);
  if (rankDiff !== 0) return rankDiff;

  if (!a.adult && !b.adult) {
    let dateA = a.dob ? new Date(a.dob) : new Date();
    let dateB = b.dob ? new Date(b.dob) : new Date();
    return dateA.getTime() - dateB.getTime();
  }

  return 0;
};

export const urlSearchParams = (type, params, startsWith) => {
  if (!params) {
    return '';
  }
  return startsWith + type + '=' + params;
}

export const isAuthenticatedCustomer = (sessionUser) => {
  return isSessionCustomer(sessionUser) && sessionUser.guid?.length > 0;
}

export const timeBlockEvent = (event) => {
  return event.timeBlockParentGuid?.length > 0 && event.timeBlockEvents?.length > 0;
}

export const maxMatrixPrice = (event) => {
  let p = 0;
  if (event?.eventMatrix && event?.eventMatrix.entries?.length > 0) {
    for (let j in event?.eventMatrix.entries) {
      if (event?.eventMatrix.entries[j].price > p) {
        p = event?.eventMatrix.entries[j].price;
      }
    }
  }
  return p;
}

export const validEvent = (event, caller) => {
  return isValidEvent(event, event?.eventType, caller);
}

export const isValidEvent = (event, eventType, caller) => {

  let today = new Date();
  today.setHours(0, 0, 0, 0);
  let validAllDayEvent = event.allDay && new Date(event.eventEndDate).getTime() >= today.getTime();

  if ('Single' === caller) {
    // fall through normal single event logic
  } else {
    if (event.timeBlockParentGuid?.length > 0 && event.timeBlockEvents?.length > 0) {
      const start = dayjs().startOf('day');
      const eventDate = dayjs(event.eventDate);
      if (eventDate.startOf('day').diff(today, 'day') < 0) {
        return false;
      }
      if (!eventType?.restrictedBooking) {
        return true;
      }
    }
  }

  if (eventType?.ongoingBooking) {
    return validAllDayEvent || new Date(event.eventEndDate).getTime() >= new Date().getTime();
  } else if (eventType?.restrictedBooking) {
    let timeUnit = parseInt(eventType?.restrictedBookingType, 10);
    let restrictedBookingValue = eventType?.restrictedBookingValue;
    let diff = new Date(event.eventDate).getTime() - new Date().getTime();
    const now = new Date().getTime();
    const target = new Date(event.eventDate).getTime();
    const difference = target - now;

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference) / (1000 * 60 * 60));
    const minutes = Math.floor((difference) / (1000 * 60));

    if (timeUnit === CONSTANTS.TIME_UNIT.MINUTE) {
      return minutes >= restrictedBookingValue;
    } else if (timeUnit === CONSTANTS.TIME_UNIT.HOUR) {
      return hours >= restrictedBookingValue;
    } else if (timeUnit === CONSTANTS.TIME_UNIT.DAY) {
      return days >= restrictedBookingValue;
    }
  }

  return validAllDayEvent || new Date(event.eventDate).getTime() >= new Date().getTime();
}

export const isSessionPending = (sessionUser) => {
  if (!sessionUser) {
    return true;
  }
  if (sessionUser?.userTypeId === null) {
    return true;
  }
  return false;
};

export const isSessionCustomer = (sessionUser) => {
  if (!sessionUser) {
    return false;
  }
  if (sessionUser?.userTypeId === CONSTANTS.UTYPE_CUSTOMER) {
    return true;
  }
  return false;
};

export const isSessionClient = (sessionUser) => {
  if (!sessionUser) {
    return false;
  }
  if (sessionUser?.userTypeId === CONSTANTS.UTYPE_CLIENT) {
    return true;
  }
  return false;
};

export const isSessionSuperAdmin = (sessionUser) => {
  if (!sessionUser) {
    return false;
  }
  if (sessionUser?.userTypeId === CONSTANTS.UTYPE_ADMIN) {
    return true;
  }
  return false;
};

export const formatDateNoTz = (jsDate) => {
  let d = new Date(jsDate.split('-'));
  return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear();
}

export const toDate = (dateString) => {
  if (!dateString) {
    return new Date();
  }
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
}

export const formatAge = (familyMember) => {
  let dob = familyMember.dob;
  if (!dob) {
    return;
  }

  const [year, month, day] = dob.split('-').map(Number);
  let d = new Date(year, month - 1, day);
  let e6age = Math.floor((new Date() - new Date(d).getTime()) / 3.15576e+10);

  if (e6age > 0) {
    return (e6age) + ' years';
  } else {
    return (Math.floor((new Date().getTime() - new Date(d).getTime()) / 1000 / 60 / 60 / 24 / 30)) + ' months';
  }
}

export const getDateNoTz = (jsDate) => {
  return new Date(jsDate.split('-'));
}

export const formatDate = (jsDate) => {
  let d = new Date(jsDate);
  return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear();
}

function addPadding(value) {
  return value < 10 ? '0' + value : value;
}

function formatIsoDate(dateStr) {
  const date = new Date(dateStr);
  return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
}


export const formatTime = (jsDate) => {
  let d = new Date(jsDate);
  const hours = d.getHours();
  const amPm = hours >= 12 ? 'PM' : 'AM';
  return (hours > 12 ? hours - 12 : hours) + ":" + addPadding(d.getMinutes()) + ' ' + amPm;
}

export const addDate = (date, numberDays) => {
  let result = new Date(date);
  result.setDate(result.getDate() + numberDays);
  return new Date(result);
}

export const inventoryAvailable = (inventory) => {
  if (!inventory) {
    return 0;
  }
  if (inventory?.eventType?.specialEvent) {
    return inventory?.totalAvailable;
  }
  return inventory?.publicAvailableQuantity || 0;
}

export const displayDuration = (inventory) => {
  if (inventory?.allDay) {
    return 'All Day';
  }
  let duration = inventory?.duration || 0;
  if (duration < 60) {
    return duration + ' minutes';
  }
  let hours = Math.floor(duration / 60);
  let minutes = duration % 60;

  let displayHours = hours > 1 ? ' hours' : ' hour';

  return hours + displayHours + (minutes > 0 ? ' ' + minutes + ' minutes' : '');
}

export const formatDateTimeTz = (eventUtc, mask, tz) => {

  const date = new Date(eventUtc);

  let displayDate = null;

  try {
    displayDate = momentTz.tz(eventUtc, tz);
  } catch (err) {
    displayDate = momentTz.tz(new Date(), tz);
  }

  return displayDate.format(mask);
}


export const formatDateTime = (jsDate) => {
  return momentTz(jsDate).format('MM/DD/yyyy hh:mm a');
}

export const prettyDateTime = (jsDate) => {
  return momentTz(jsDate).format('dddd, MMMM Do, YYYY h:mm a');
}


export const displayEventTime = (event, timeZone, mask) => {
  if (!mask) {
    mask = 'MM/DD/YYYY h:mm a';
  }
  let d = formatDateTimeTz(event.eventDate, mask, timeZone);
  if (event?.eventType?.hideEndTime) {
    return d;
  }
  d += ' - ' + formatDateTimeTz(event.eventEndDate, 'h:mm a', timeZone);
  return d;
}

export const formatDateMask = (jsDate, mask) => {
  return momentTz(jsDate).format(mask);
}

export const displayDay = (jsDate, format) => {
  return momentTz(jsDate).format(format);
}

export const displayDayTz = (jsDate, format, tz) => {
  return formatDateTimeTz(jsDate, format, tz);
}

export const formatCurrency = (price) => {
  if (isNaN(price)) {
    return '';
  }

  return '$' + parseFloat(Math.round(100 * price) / 100)
    .toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
}

export const formatDouble = (price) => {
  if (isNaN(price)) {
    return '';
  }

  return parseFloat(Math.round(100 * price) / 100)
    .toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
}


export const customerQrCode = (customer) => {
  return 'https://psb.com/qr/cx/' + customer.id + '/' + customer.guid;
}

export const handleDefaultValues = (entity) => {
  if (!entity) {
    return entity;
  }

  if (entity.primaryPhone) {
    entity.primaryPhone = displayPhone(entity.primaryPhone);
  }

  return entity;
};

export const displayPhone = (phoneNumberString) => {
  let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    let intlCode = (match[1] ? '+1 ' : '');
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }

  return phoneNumberString;
}

export const capitalize = (s) => {
  if (!s) {
    return s;
  }
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export const formatExpiration = (expiration) => {
  let cleaned = ('' + expiration).replace(/\D/g, '');

  let expy = cardValidator.expirationDate(expiration);

  // format expiration into MM/YY format
  let match = cleaned.match(/^(0[1-9]|1[0-2])\/?([0-9]{0,4})$/);
  if (match) {
    expiration = [match[1], '/', match[2]].join('');
  }

  expy.expy = expiration;

  return expy;
}


export const formatCreditCard = (cardNumber) => {
  let cleaned = ('' + cardNumber).replace(/\D/g, '');

  let card = cardValidator.number(cardNumber);

  if (card.isPotentiallyValid) {
    cardNumber = cardNumber.replace(/\D/g, '');
    cardNumber = cardNumber.replace(/(\d{4})/g, '$1 ');
    cardNumber = cardNumber.trim();
  }
  card.cardNumber = cardNumber;

  return card;
}

export const customerInitials = (customer) => {
  let s = '';
  s += customer && customer.firstName ? customer.firstName.split('')[0] + '' : '';
  s += customer && customer.lastName ? customer.lastName.split('')[0] + '' : '';
  return s.toUpperCase();
}

export const invert = (hex, bw) => {

  if (!hex) {
    return '#000';
  }

  function padZero(str, len) {
    len = len || 2;
    let zeros = new Array(len).join('0');
    return (zeros + str).slice(-len);
  }


  if (hex.indexOf('#') === 0) {
    hex = hex.slice(1);
  }
  // convert 3-digit hex to 6-digits.
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  if (hex.length !== 6) {
    throw new Error('Invalid HEX color.');
  }
  let r = parseInt(hex.slice(0, 2), 16),
    g = parseInt(hex.slice(2, 4), 16),
    b = parseInt(hex.slice(4, 6), 16);
  if (bw) {
    // https://stackoverflow.com/a/3943023/112731
    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
      ? '#000000'
      : '#FFFFFF';
  }
  // invert color components
  r = (255 - r).toString(16);
  g = (255 - g).toString(16);
  b = (255 - b).toString(16);
  // pad each with zeros and return
  return "#" + padZero(r) + padZero(g) + padZero(b);
}

export const colorize = (str) => {
  if (!str) {
    return '#efefef';
  }
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let colour = '#';
  for (let j = 0; j < 3; j++) {
    let value = (hash >> (j * 8)) & 0xFF;
    colour += ('00' + value.toString(16)).substr(-2);
  }
  return colour;
}

export const truncDetail = (desc, length) => {
  if (!desc) {
    return '';
  }

  let _d = desc.split(' ');
  let _e = '';
  for (let i = 0; i < _d.length && i < length; i++) {
    _e += (i === 0 ? '' : ' ') + _d[i];
  }
  if (_d.length > length) {
    _e += '...';
  }
  return _e;
}

const DOB_MIN_YEAR = new Date().getFullYear() - 100;
const DOB_MAX_DATE = new Date();
DOB_MAX_DATE.setHours(0, 0, 0, 0);
const DOB_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

export const DOB_INPUT_MIN = `${DOB_MIN_YEAR}-01-01`;
export const DOB_INPUT_MAX = DOB_MAX_DATE.toISOString().slice(0, 10);

export const isValidDob = (value) => {
  if (!value) {
    return false;
  }
  const match = DOB_DATE_PATTERN.exec(value);
  if (!match) {
    return false;
  }
  const year = parseInt(match[1], 10);
  const month = parseInt(match[2], 10);
  const day = parseInt(match[3], 10);
  if (year < DOB_MIN_YEAR || year > DOB_MAX_DATE.getFullYear()) {
    return false;
  }
  // Build the date from its numeric parts (rather than re-parsing the
  // string) and check it round-trips — the Date constructor silently
  // rolls overflow days/months forward (e.g. Feb 30 becomes Mar 1-2),
  // so a mismatch here means the typed value wasn't a real calendar date.
  const parsed = new Date(year, month - 1, day);
  if (
    Number.isNaN(parsed.getTime()) ||
    parsed.getFullYear() !== year ||
    parsed.getMonth() !== month - 1 ||
    parsed.getDate() !== day
  ) {
    return false;
  }
  return parsed <= DOB_MAX_DATE;
}
